
export const EMPLOYEE_TABLE_FIELDS = [
    { key: "emp_id", label: "emp id" },
    { key: "emp_email", label: "emp email" },
    { key: "emp_first_name", label: "emp first name" },
    { key: "emp_last_name", label: "emp last name" },
    { key: "role_title", label: "role title" },
    { key: "role_position", label: "role position" },
    { key: "profiles", label: "profile/s" },
    { key: "reporting_mgr_name", label: "reporting mgr name" },
    { key: "rep_mgr_emp_id", label: "rep mgr emp id" },
    { key: "hrbp_name", label: "hrbp name" },
    { key: "hrbp_emp_id", label: "hrbp emp id" },
  ];

export const TABLE_FILTER_CONSTANTS = {
  ALL: "all",
  COMPLETE: true,
  INCOMPLETE: false
};

export const MANAGER_TYPE = {
  REPORTING_MANAGER: "reporting-manager",
  HRBP: "hrbp"
};

export const ERROR_MESSAGES = {
  SELECT_HRBP: "Please select HRBP.",
  SELECT_REPORTING_MANAGER: "Please select reporting manager.",
  SELECT_AT_LEAST_ONE_ROLE: "Please select at least one role position.",
  SELECT_PROFILE_ASSIGNMENT: "Please select a profile assignment.",
  SOMETHING_WENT_WRONG: "Something went wrong!"
};